module.exports = __webpack_public_path__ + "img/icon-twitter.ab0cb6fd.svg";